import { render, staticRenderFns } from "./Action_satisfaction.vue?vue&type=template&id=1f66c052&scoped=true"
import script from "./Action_satisfaction.vue?vue&type=script&lang=js"
export * from "./Action_satisfaction.vue?vue&type=script&lang=js"
import style0 from "./Action_satisfaction.vue?vue&type=style&index=0&id=1f66c052&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f66c052",
  null
  
)

export default component.exports